import { Container, Box, Heading } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { UpcomingEventCard } from '@/components/ui/shared/event/EventCard/EventCard';
import { FeaturedUpcomingEventCard } from '@/components/ui/shared/event/FeaturedEventCard/FeaturedEventCard';
import { ThinEvent } from '@/resources/ThinEvent';
import { getEventHref } from '@/utils/getEventHref';

interface IEventProps {
  event: ThinEvent;
}

export const FeaturedEvent: FC<IEventProps> = ({ event }) => {
  const { t } = useTranslation();

  return (
    <Box bgColor="black">
      <Container>
        <Box w="full" position="relative" bottom="-80px">
          <Heading
            color="white"
            mb={{ base: 6, lg: 10 }}
            lineHeight={{ base: 'taller', lg: '2.75rem' }}
            fontSize={{ base: '2xl', lg: '2rem' }}
            hideBelow="md"
          >
            {t('eventsPage.featuredConferences')}
          </Heading>
          <NextLink key={event.id} href={getEventHref(event)} passHref legacyBehavior>
            <UpcomingEventCard as="a" event={event} hideFrom="md" />
          </NextLink>
          <NextLink key={event.id} href={getEventHref(event)} passHref legacyBehavior>
            <FeaturedUpcomingEventCard as="a" event={event} hideBelow="md" />
          </NextLink>
        </Box>
      </Container>
    </Box>
  );
};
